'use client'

import React from 'react'
import { Box, Stack, Title } from '@mantine/core'
import { SkuDetailCta } from './SkuDetailCta'
import { Sku } from '@/types/interfaces/sku'

interface SkuCTAProps {
    title?: string
    backgroundColor?: string
    sku: Sku
    buttonSize?: 'lg' | 'md'
    skuPageVariant?: 'refresh' | 'legacy'
}

const BookSkuCTA: React.FC<SkuCTAProps> = ({ title = 'Take the first step to better health today.', sku, skuPageVariant }) => {
    return (
        <Stack
            maw={600}
            m={'0 auto'}
            h={430}
            ta={'center'}
            justify={'center'}
            p={24}
            gap={30}
            data-testid="book-sku-cta-container"
        >
            {renderTitle()}
            {renderCTAButton()}
        </Stack>
    )

    function renderTitle() {
        return (
            <Title
                order={2}
                c={'var(--GM-Text-Black, #181818)'}
                ta={'center'}
                fz={{ base: 36, md: 48 }}
                fw={{ base: 500, md: 400 }}
                lh={{ base: '43px', md: '70px' }}
                lts={{ base: '-0.72px', md: '-1.08px' }}
            >
                {title}
            </Title>
        )
    }

    function renderCTAButton() {
        return (
            <Box px={{ base: 30, md: 125 }}>
                <SkuDetailCta sku={sku} skuPageVariant={skuPageVariant} />
            </Box>
        )
    }
}

export default BookSkuCTA
